import { string } from "prop-types";

export default {
  id: string,
  label: string,
  short_code: string,
  __typename: string
};
